import React from 'react';
export default class SpecialsItem extends React.Component {

  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
    return (
        <a key={this.props.data.link} href={this.props.data.link} className="special">
           <span className="img_wrap"><img src={this.props.data.image} alt="" /></span>
           <span className="copy_wrap">
             <h4>{this.props.data.title}</h4>
             <span className="price">{this.props.data.price}</span>
           </span>
         </a>)
  }
}
